import React, { useState, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import Loader from './components/loader/loader';
import ErrorBoundary from './components/error-boundary/error-boundary';
import VideocallWrapper from '@components/video-call/components/videocallWrapper';
import { io, Socket } from 'socket.io-client';
import { VideoCallSocketContext } from './contexts/videocall';
import { socket_url as socketVideoUrl, socket_video_path as socketVideoPath } from './environments/video-call-variables';
import VideocallGroupWrapper from '@components/video-call/components/videocallGroupWrapper';
import { environment } from './environments/environment';
import { CameraContext } from '@fc/videocall/Contexts/cameraContext';
import { VoiceCallContext } from '@contexts/voiceCallContext';
import { useVoicetimer } from '@customHooks/voice-call/use-voice-timer';
import { useVideoTimer } from '@customHooks/video-call/use-videocall-timer';
import router from './router';

function App() 
{
    const [socketVideo, setSocketVideo] = useState<Socket | null>(null);
    //This states are used to track the Camera selection in the app
    const [camera, setCamera] = useState<MediaDeviceInfo>();
    const { time: voiceTime, showTimer: showVoiceTimer, expired: voiceCallExpired, resetStates: resetVoiceTimerStates } = useVoicetimer({
        config: { hours: 0, minutes: 5, seconds: 0}
    })
    const { time: videoTime, showTimer: showVideoTimer, expired: videoCallExpired, resetStates: resetVideoTimerStates } = useVideoTimer({
        config: { hours: 0, minutes: 5, seconds: 0}
    })

    const [voiceCounterIsAllowed, setVoiceCounterIsAllowed] = useState<boolean>(false)
    const [videoCounterIsAllowed, setVideoCounterIsAllowed] = useState<boolean>(false)

    useEffect(() => {
        const initScript = document.createElement('script');
        initScript.setAttribute("type", "text/javascript");
        const initCode = `window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}`
        initScript.appendChild(document.createTextNode(initCode));
        document.body.appendChild(initScript);

        const widgetScript = document.createElement('script');
        widgetScript.id = "zsiqscript";
        widgetScript.src = "https://salesiq.zohopublic.com/widget?wc=siq138533b74b74ff5480be0ffb06806d7e0bf471fc00e9315338f1ac68ca99fc32";
        widgetScript.defer = true;
        document.body.appendChild(widgetScript);

        document.title = environment.env
    }, [])

    const createSocketVideo = () => {
        if(socketVideo) return;
        const tmpSocket = io(socketVideoUrl, { path: socketVideoPath });
        setSocketVideo(tmpSocket);
    }
    const VoiceCallContextValues = { 
        time: voiceTime, 
        showTimer: showVoiceTimer, 
        expired: voiceCallExpired, 
        resetStates: resetVoiceTimerStates, 
        counterIsAllowed: voiceCounterIsAllowed, 
        setCounterIsAllowed: setVoiceCounterIsAllowed 
    }
    
    const VideoCallContextValues = { 
        socketVideo,
        time: videoTime, 
        showTimer: showVideoTimer, 
        expired: videoCallExpired, 
        resetStates: resetVideoTimerStates, 
        counterIsAllowed: videoCounterIsAllowed, 
        setCounterIsAllowed: setVideoCounterIsAllowed 
    }

    return (
        <CameraContext.Provider value={{camera, setCamera}}>
            <VoiceCallContext.Provider value={VoiceCallContextValues}>
                <VideoCallSocketContext.Provider value={VideoCallContextValues}>
                    <VideocallWrapper onCreateSocketVideo={createSocketVideo} 
                        expired={videoCallExpired} 
                        resetStates={resetVideoTimerStates} />
                    <VideocallGroupWrapper/>

                    <ErrorBoundary>
                        <React.Suspense fallback={<Loader />}>
                            <RouterProvider router={router} />
                        </React.Suspense>
                    </ErrorBoundary>
                </VideoCallSocketContext.Provider>
            </VoiceCallContext.Provider>
        </CameraContext.Provider>
  );
}

export default App;
